// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionRuntimeValues = {
  values: {
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "Port Mapping",
    noAccessEndpoints: "No access endpoints",
    workspaceAccessOnly: "Only accessible from the runtime node",
    providerTypeLocal: "Local",
    providerTypeCenter: "Asset Center",
    executionProviderTypeLocal: "Local Execution",
    executionProviderTypeCenter: "Execution Fabric",
    providerTypeLocalRuntime: "Local Runtime",
    providerKeyLocalRuntimeDocker: "Local Runtime Docker",
    providerKeyLocalRuntimeKvm: "Local Runtime KVM",
    providerKeyAliyunAckContainer: "Aliyun ACK Container",
    providerKeyAliyunEcsKvm: "Aliyun ECS KVM",
    providerKeyUnknown: "Undefined Provider",
    sourceTypeQuestionEditorPracticalDebug: "Question Editor Practical Debug",
    sourceTypeQuestionEditorAttackDebug: "Question Editor Attack Defense Debug",
    sourceTypeRuntimeDocker: "Runtime Docker Instance",
    objectTypeQuestionEditorDebug: "Question Editor Debug Instance",
    objectTypeDockerInstance: "Standalone Container Instance",
    environmentTypeDebug: "Debug Environment",
    instanceKindBusiness: "Business Instance",
    instanceKindDebug: "Debug Instance",
    instanceKindRuntime: "Runtime Instance",
    instanceKindPractical: "Practical Container Instance",
    instanceKindVm: "VM Instance",
    instanceKindRuntimeVm: "Runtime VM Instance",
    actionCreateEnvironment: "Create Environment Instance",
    actionCreateDocker: "Create Container Instance",
    actionImportTar: "Import Image Tar",
    actionImportAsset: "Import Image From Asset",
    actionBuildDockerfile: "Build From Dockerfile",
  },
} as const;
